import React from "react";
import Header from "../../../shared/layout/Header";
import ColorInit from "../../../shared/layout/ColorInit";
import { CartProvider } from "../../cart/context/CartContext";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import MyOrders from "../components/MyOrders";
//import AddressBook from "../../account/components/AddressBook";
import ScrollToTop from "react-scroll-to-top";

const MyOrdersPage = () => {
  return (
    <CartProvider>
      <ScrollToTop smooth color="#ef253c" />
      <ColorInit color={"bigmall"} />
      <Header />
      {/* <AddressBook /> */}
      <div className="container container-lg">
        <MyOrders />
      </div>
      <Footer />
      <BottomFooter />
    </CartProvider>
  );
};

export default MyOrdersPage;
